import {merge} from '../base/actions';

export const mergeFilterOptions = (controllerName, options = {}) => merge([controllerName, 'options'], options);
